export const TableColumns = [
  { key: 'sn', label: '' },
  { key: 'action', label: 'Action' },
  { key: 'KitId', label: 'Kits' },
  { key: 'CustId', label: 'Cust #' },
  { key: 'CustomerName', label: 'Customer' },
  { key: 'PurchaseOrderNumber', label: 'PO#' },
  { key: 'shipDate', label: 'Ship Date' },
  { key: 'BillAmount', label: 'Bill Amt' },
  { key: 'billed', label: 'Billed' },
  { key: 'createdBy', label: 'Created By' },
];

export const ViewOilKitsColumns = [
  { key: 'kitId', label: '' },
  { key: 'kitno', label: 'Kit #' },
];

export const OilKitsSelectorColumns = [
  { key: 'sn', label: '' },
  { key: 'action', label: 'Action' },
  { key: 'customer', label: 'Customer' },
  { key: 'shipDate', label: 'Ship Date' },
];
